module.exports = __webpack_public_path__ + "static/media/arrowBackGray.74c122e7.svg";